import { Card, CardBody, Col } from "reactstrap";
import { dynamicImage } from "../../../utils";
import { SmallScrollText, SmallSizeScrollTitle } from "../../../constants";
import { SmallSizeScrollSubTitle } from "../../../data/bonusUi/Scrollable";
import ScrollBar from "react-perfect-scrollbar";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import { Image } from "../../../coreComponents/Image";

const SmallSizeScroll = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={SmallSizeScrollTitle} span={SmallSizeScrollSubTitle} />
        <CardBody>
          <div className="scroll-bar-wrap">
            <ScrollBar className="scroll-demo pe-0 custom-container">
              <div>
                <h5 className="pb-2">{SmallScrollText}</h5>
              </div>
              <p>
                {"The Business Transformation Solution programme is a "}
                <em className="txt-danger">{"multi-level engagement program"}</em>
                {" is designed to help Small and Medium-Sized Businesses and Startups create a strong, well-functioning business organization that produces the best results quickly and effectively."}
                <Image className="img-fluid pt-3" src={dynamicImage(`banner/3.jpg`)} alt="business" />
              </p>
              <p className="m-b-0">
                {"The core of the programme is our internally developed "}
                <em className="txt-danger">{"Business Management model"}</em>
                {', "Business Foundation & Management", which was tried and true for Indian business conditions while drawing inspiration from other successful global SME Business Management techniques.'}
              </p>
            </ScrollBar>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default SmallSizeScroll;
